import { css } from '@/styled-system/css';

export const formStyles = css.raw({
  '& [data-c11n-component="FormActions"]': {
    marginBlockStart: 'layout.loose',
  },
  '& [data-c11n-component="FormField"]:not(:last-child)': {
    marginBlockEnd: 'layout.tight',
  },
  '& [data-c11n-component="FieldSet"]:not(:last-child)': {
    marginBlockEnd: 'layout.tight',
  },
});
